var render = function render(_c, _vm) {
  return _c(
    "article",
    {
      staticClass: "padding-y-5xl inverted",
      staticStyle: { "background-color": "var(--fa-dk-navy)" },
      attrs: { id: "warning-internet-explorer" },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            staticClass:
              "warning-internet-explorer text-center tablet:text-left",
          },
          [
            _c(
              "div",
              { staticClass: "warning-internet-explorer-decorative" },
              [
                _c("font-awesome-icon", {
                  attrs: {
                    icon: _vm.parent.$v6.solid.faSpaceStationMoonConstruction,
                    "fixed-width": "",
                    size: "3x",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "tablet:margin-left-7xl" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "warning-internet-explorer-action" }, [
                _c(
                  "a",
                  {
                    staticClass: "button yellow text-nowrap",
                    staticStyle: { "--button-background": "transparent" },
                    attrs: {
                      href: "https://browsehappy.com/",
                      target: "_blank",
                      rel: "nofollow",
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "margin-right-2xs",
                      attrs: {
                        icon: _vm.parent.$v6.solid.faStarfighter,
                        size: "lg",
                        rotation: "90",
                      },
                    }),
                    _vm._v("\n            Be a Rebel – Upgrade!\n          "),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function (_c, _vm) {
    return _c(
      "div",
      {
        staticClass:
          "warning-internet-explorer-message margin-y-2xl tablet:margin-top-0",
      },
      [
        _c("h1", { staticClass: "h4" }, [
          _vm._v("\n            That's No Moon!\n            "),
          _c(
            "strong",
            {
              staticClass: "margin-left-4xs",
              staticStyle: { color: "var(--fa-yellow)" },
            },
            [
              _vm._v(
                "\n              And This Isn't a Modern Browser!\n            "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "laptop:line-length-lg" }, [
          _vm._v(
            "\n            You're using Internet Explorer, an\n            "
          ),
          _c(
            "a",
            {
              attrs: {
                href: "https://techcommunity.microsoft.com/t5/microsoft-365-blog/microsoft-365-apps-say-farewell-to-internet-explorer-11-and/ba-p/1591666",
                target: "_blank",
                rel: "nofollow",
              },
            },
            [_vm._v("\n              outdated\n            ")]
          ),
          _vm._v("\n            and\n            "),
          _c(
            "a",
            {
              attrs: {
                href: "https://blogs.windows.com/windowsexperience/2021/05/19/the-future-of-internet-explorer-on-windows-10-is-in-microsoft-edge/",
                target: "_blank",
                rel: "nofollow",
              },
            },
            [_vm._v("\n              soon to be unsupported\n            ")]
          ),
          _vm._v(
            "\n            browser. Using such a browser can make your experience on this site nowhere near Awesome, put your computer at risk, and may even lead to the dark\n            side...\n          "
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }